<script setup>

    defineProps({
        message: {
            type: String,
        },
    })

</script>

<template>
    <div v-show="message">
        <p class="text-sm text-lifeworx-red-500 font-semibold dark:text-lifeworx-red-400">
            {{ message }}
        </p>
    </div>
</template>
